import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ImageUploader from './imageUploader';
import DateComponent from './dateComponent';
import dayjs from 'dayjs'; // Import dayjs
import { calculateAge } from '../helpers/calculateAge';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../api/patientApi';
import { PATIENT_FILE_TAGS } from '../../../constants/index';
const maritalStatusOptions = [
  'Single',
  'Married',
  'Divorced',
  'Widowed',
  'Separated',
  'Domestic',
  'Partner',
];
const isOtherValue = (options, value) => {
  return !options.includes(value);
};

const BasicDetails = ({
  patientFormData,
  setPatientFormData,
  submeet,
  validateField,
  validateExactLength,
  validateIsNumber,
  validateEmail,
  validatePhoneNumber,
  touchedFields,
  setTouchedFields,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [effectRan, setEffectRan] = useState(false); // State to track if effect has run
  const [otherValue, setOtherValue] = useState('');

  useEffect(() => {
    if (!patientFormData.basicDetails.dob) {
      setSelectedDate(null);
    }
    if (!effectRan && patientFormData.basicDetails.dob) {
      const parsedDate = dayjs(patientFormData.basicDetails.dob); // Use dayjs to parse the date
      if (!parsedDate.isValid()) {
        console.error('Invalid date format');
        return;
      }
      const age = calculateAge(parsedDate);
      setSelectedDate(parsedDate);
      setPatientFormData({
        ...patientFormData,
        basicDetails: {
          ...patientFormData.basicDetails,
          dob: patientFormData.basicDetails.dob,
          age: age,
        },
      });
      // setEffectRan(true); // Mark effect as run
    }
  }, [effectRan, patientFormData.basicDetails.dob]);

  const handleDateChange = (date, dateString) => {
    setSelectedDate(date);
    const age = calculateAge(date);
    setPatientFormData({
      ...patientFormData,
      basicDetails: {
        ...patientFormData.basicDetails,
        dob: dateString,
        age: age,
      },
    });
  };
  const changeHandler = (e) => {
    setPatientFormData({
      ...patientFormData,
      basicDetails: {
        ...patientFormData.basicDetails,
        [e.target.name]: e.target.value,
      },
    });
  };

  const changePhoneHandler = (value) => {
    setPatientFormData({
      ...patientFormData,
      basicDetails: {
        ...patientFormData.basicDetails,
        phoneNumber: value,
      },
    });
  };

  const uploadImageAndSave = async (selectedFile, patientId) => {
    try {
      const response = await uploadPatientFileApi(
        selectedFile,
        patientId,
        'Profile',
        updateFileStatusUploaded,
        PATIENT_FILE_TAGS.PROFILE_IMAGE,
      );
    } catch (error) {
      console.log('Error uploading file:', error);
      throw new Error('File upload failed');
    }
  };

  return (
    <div className="card">
      <div className="header">
        <p className="lead">Basic Details</p>
      </div>

      <div className="body">
        {/* Personal Details */}
        <div className="row clearfix">
          <div className="form-group col-lg-4 col-md-12">
            <ImageUploader
              name="profileImage"
              profileImageUrl={
                patientFormData.basicDetails.profileImagePresignedUrl
              }
              buttonLabel={'Upload'}
              bodyLabel={'Upload profile image'}
              uploadAndSaveHandler={uploadImageAndSave}
            />
          </div>
        </div>
        <div className="row clearfix">
          <div className="form-group col-lg-4 col-md-12">
            <label>MPI No</label>
            <input
              // className={`form-control ${patientFormData.basicDetails.firstName === '' && submeet && 'parsley-error'}`}
              className={`form-control`}
              value={patientFormData.upid}
              name="upid"
              required=""
              disabled={true}
            />
            {/* {patientFormData.basicDetails.firstName === '' && submeet && (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            )} */}

            {validateField(patientFormData.basicDetails.firstName, 50)
              .errorMessage && (
              <span className="error">
                {
                  validateField(patientFormData.basicDetails.firstName, 50)
                    .errorMessage
                }
              </span>
            )}
          </div>
          <div className="form-group col-lg-4 col-md-12">
            <label>
              First Name
              <span className="mandatory_fields">*</span>
            </label>
            <input
              // className={`form-control ${patientFormData.basicDetails.firstName === '' && submeet && 'parsley-error'}`}
              className={`form-control ${validateField(patientFormData.basicDetails.firstName, 50).isInvalid ? 'is-invalid' : ''}`}
              value={patientFormData.basicDetails.firstName}
              name="firstName"
              required=""
              onChange={changeHandler}
            />
            {/* {patientFormData.basicDetails.firstName === '' && submeet && (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            )} */}

            {validateField(patientFormData.basicDetails.firstName, 50)
              .errorMessage && (
              <span className="error">
                {
                  validateField(patientFormData.basicDetails.firstName, 50)
                    .errorMessage
                }
              </span>
            )}
          </div>
          <div className="form-group col-lg-4 col-md-12">
            <label>Middle Name</label>
            <input
              className={`form-control`}
              value={patientFormData.basicDetails.middleName}
              name="middleName"
              onChange={changeHandler}
            />
          </div>

          <div className="form-group col-lg-4 col-md-6">
            <label>
              Last Name
              <span className="mandatory_fields">*</span>
            </label>
            <input
              // className={`form-control ${patientFormData.basicDetails.lastName === '' && submeet && 'parsley-error'}`}
              className={`form-control ${validateField(patientFormData.basicDetails.lastName, 50).isInvalid ? 'is-invalid' : ''}`}
              value={patientFormData.basicDetails.lastName}
              name="lastName"
              required=""
              onChange={changeHandler}
            />

            {/* {patientFormData.basicDetails.lastName === '' && submeet && (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            )} */}

            {validateField(patientFormData.basicDetails.lastname, 50)
              .errorMessage && (
              <span className="error">
                {
                  validateField(patientFormData.basicDetails.lastname, 50)
                    .errorMessage
                }
              </span>
            )}
          </div>

          <div className="form-group col-lg-4 col-md-6">
            <input
              type="checkbox"
              checked={patientFormData.basicDetails.isNRI}
              name="isNRI"
              onChange={(e) => {
                setPatientFormData({
                  ...patientFormData,
                  basicDetails: {
                    ...patientFormData.basicDetails,
                    isNRI: e.target.checked,
                  },
                });
              }}
              id="isNRI"
              className=""
              style={{
                marginTop: '45px',
              }}
            />
            <label htmlFor="isNRI" className="ml-3">
              Is NRI/Foreigner
            </label>
          </div>

          <div className="form-group col-lg-4 col-md-6">
            <label>
              Passport Number
              {patientFormData.basicDetails.isNRI && (
                <span className="mandatory_fields">*</span>
              )}
            </label>
            <input
              // className={`form-control ${patientFormData.basicDetails.adharNumber === '' && submeet && 'parsley-error'}`}
              className={`form-control`}
              value={patientFormData.basicDetails.passportNumber}
              name="passportNumber"
              required=""
              onChange={(e) => {
                changeHandler(e);
              }}
            />
          </div>
        </div>
        {/* Professional Details */}
        <div className="row clearfix">
          <div className="form-group col-lg-4 col-md-12">
            <label>
              Aadhar Number
              {!patientFormData.basicDetails.isNRI && (
                <span className="mandatory_fields">*</span>
              )}
            </label>
            <input
              // className={`form-control ${patientFormData.basicDetails.adharNumber === '' && submeet && 'parsley-error'}`}
              className={`form-control ${touchedFields.adharNumber && !patientFormData.basicDetails.isNRI && !validateExactLength(patientFormData.basicDetails.adharNumber, 12) ? 'is-invalid' : ''}`}
              value={patientFormData.basicDetails.adharNumber}
              name="adharNumber"
              required=""
              // onChange={(e) => {
              // const value = e.target.value;
              // if (/^\d{0,12}$/.test(value)) {
              //     setFormData((prevData) => ({
              //     ...prevData,
              //     adharNumber: value,
              //     }));
              //     setSubmeet(false);
              // }
              // }}
              onChange={(e) => {
                changeHandler(e);
                setTouchedFields({ ...touchedFields, adharNumber: true });
              }}
            />

            {touchedFields.adharNumber &&
              !validateExactLength(
                patientFormData.basicDetails.adharNumber,
                12,
              ) && (
                <span className="error">
                  Aadhar Number should be exactly 12 digits.
                </span>
              )}

            {/* {patientFormData.basicDetails.adharNumber === '' && submeet ? (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            ) : null} */}
          </div>
          <div className="form-group col-lg-4 col-md-6">
            <label>
              Email Address
              <span className="mandatory_fields">*</span>
            </label>
            <input
              // className={`form-control ${patientFormData.basicDetails.emailAddress === '' && submeet && 'parsley-error'}`}
              className={`form-control ${touchedFields.emailAddress && (validateField(patientFormData.basicDetails.emailAddress, 50).isInvalid || !validateEmail(patientFormData.basicDetails.emailAddress)) ? 'is-invalid' : ''}`}
              value={patientFormData.basicDetails.emailAddress}
              name="emailAddress"
              required
              onChange={(e) => {
                changeHandler(e);
                setTouchedFields({ ...touchedFields, emailAddress: true });
              }}
            />
            {/* {patientFormData.basicDetails.emailAddress === '' && submeet && (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            )} */}

            {touchedFields.emailAddress && (
              <>
                {validateField(patientFormData.basicDetails.emailAddress, 50)
                  .errorMessage && (
                  <span className="error">
                    {
                      validateField(
                        patientFormData.basicDetails.emailAddress,
                        50,
                      ).errorMessage
                    }
                  </span>
                )}
                {!validateEmail(patientFormData.basicDetails.emailAddress) && (
                  <span className="error">
                    Please enter a valid email address.
                  </span>
                )}
              </>
            )}
          </div>

          <div className="form-group col-lg-3 col-md-12">
            <label>
              Date of Birth
              <span className="mandatory_fields">*</span>
            </label>
            <DateComponent
              selectedDate={selectedDate}
              handleDateChange={handleDateChange}
            />
          </div>
          <div className="form-group col-lg-1 col-md-12">
            <label>Age</label>
            <input
              className={`form-control`}
              value={patientFormData.basicDetails.age}
              name="age"
              disabled
              // onChange={changeHandler}
            />
          </div>
        </div>
        {/* Professional Details 2 */}
        <div className="row clearfix">
          <div className="form-group col-lg-4 col-md-12">
            <label>Preferred Language</label>
            <input
              className={`form-control`}
              value={patientFormData.basicDetails.preferredLanguage}
              name="preferredLanguage"
              required=""
              onChange={changeHandler}
            />
          </div>
          <div
            className="form-group col-lg-4 col-md-12"
            style={{ marginTop: '28px' }}
          >
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <label className="input-group-text">Marital Status</label>
              </div>
              <select
                className="custom-select"
                id="inputGroupSelect01"
                name="maritalStatus"
                value={
                  isOtherValue(
                    maritalStatusOptions,
                    patientFormData.basicDetails.maritalStatus,
                  )
                    ? 'Other'
                    : patientFormData.basicDetails.maritalStatus
                }
                required
                onChange={changeHandler}
              >
                {' '}
                {[...maritalStatusOptions, 'Other'].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
            {isOtherValue(
              maritalStatusOptions,
              patientFormData.basicDetails.maritalStatus,
            ) && (
              <input
                type="text"
                className="form-control other-text-field"
                name="maritalStatus"
                value={patientFormData.basicDetails.maritalStatus}
                onChange={(e) => {
                  setOtherValue(e.target.value);
                  changeHandler(e);
                }}
                placeholder="Specify please"
              />
            )}
          </div>
          <div
            className="form-group col-lg-4 col-md-6"
            style={{ marginTop: '28px' }}
          >
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <label className="input-group-text">Gender</label>
              </div>
              <select
                className="custom-select"
                id="inputGroupSelect01"
                name="gender"
                value={patientFormData.basicDetails.gender}
                required
                onChange={changeHandler}
              >
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="form-group col-lg-4 col-md-12">
            <label>Occupation</label>
            <input
              className={`form-control`}
              value={patientFormData.basicDetails.occupation}
              name="occupation"
              required=""
              onChange={changeHandler}
            />
          </div>
          <div className="form-group col-lg-4 col-md-12">
            <label>
              Cell Phone
              <span className="mandatory_fields">*</span>
            </label>
            {/* <input
              className={`form-control ${patientFormData.basicDetails.phoneNumber === '' && submeet && 'parsley-error'}`}
              value={patientFormData.basicDetails.phoneNumber}
              name="phoneNumber"
              required
              onChange={changeHandler}
            /> */}
            <PhoneInput
              country={'in'}
              value={patientFormData.basicDetails.phoneNumber}
              onChange={(e) => {
                changePhoneHandler(e);
                setTouchedFields({ ...touchedFields, phoneNumber: true });
              }}
              disableDropdown={false}
              onlyCountries={['in', 'us', 'ca', 'uk']}
              disableCountryCode={false}
              inputProps={{
                required: true,
                placeholder: 'Enter your phone number',
              }}
            />
            {/* {patientFormData.basicDetails.phoneNumber === '' && submeet ? (
              <ul className="parsley-errors-list filled" id="parsley-id-29">
                <li className="parsley-required">This value is required.</li>
              </ul>
            ) : null} */}
            {touchedFields.phoneNumber &&
              !validatePhoneNumber(
                patientFormData.basicDetails.phoneNumber,
              ) && (
                <span className="error">
                  Please enter a valid phone number.
                </span>
              )}
          </div>
          <div className="form-group col-lg-4 col-md-12">
            <label>Home Phone</label>
            {/* <PhoneInput
              country={'in'}
              value={patientFormData.basicDetails.homePhone}
              onChange={changePhoneHandler}
              disableDropdown={true}
              onlyCountries={['in']}
              disableCountryCode={true}
            /> */}
            <input
              className={`form-control`}
              value={patientFormData.basicDetails.homePhone}
              name="homePhone"
              onChange={changeHandler}
            />
          </div>
        </div>

        <div
          className="d-flex flex-column flex-lg-row gap-8"
          style={{ gap: '1rem' }}
        >
          {/* Addresses */}
          <div className="flex col-lg-6 col-md-12  grey-box">
            <h6 className="col-lg-12 col-md-12">Permanent Address</h6>
            <div className="form-group col-lg-6 col-md-12">
              <label>
                Street Address
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${patientFormData.basicDetails.address === '' && submeet && 'parsley-error'}`}
                className={`form-control ${validateField(patientFormData.basicDetails.address, 50).isInvalid ? 'is-invalid' : ''}`}
                value={patientFormData.basicDetails.address}
                name="address"
                required=""
                onChange={changeHandler}
              />
              {/* {patientFormData.basicDetails.adressName === '' && submeet && (
                <ul className="parsley-errors-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              )} */}

              {validateField(patientFormData.basicDetails.address, 50)
                .errorMessage && (
                <span className="error">
                  {
                    validateField(patientFormData.basicDetails.address, 50)
                      .errorMessage
                  }
                </span>
              )}
            </div>
            <div className="form-group col-lg-6 col-md-12">
              <label>
                City
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${patientFormData.basicDetails.CityName === '' && submeet && 'parsley-error'}`}
                className={`form-control ${validateField(patientFormData.basicDetails.CityName, 50).isInvalid ? 'is-invalid' : ''}`}
                value={patientFormData.basicDetails.CityName}
                name="CityName"
                required=""
                onChange={changeHandler}
              />
              {/* {patientFormData.basicDetails.CityName === '' && submeet && (
                <ul className="parsley-errors-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              )} */}
              {validateField(patientFormData.basicDetails.CityName, 50)
                .errorMessage && (
                <span className="error">
                  {
                    validateField(patientFormData.basicDetails.CityName, 50)
                      .errorMessage
                  }
                </span>
              )}
            </div>
            <div className="form-group col-lg-6 col-md-12">
              <label>
                State
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${patientFormData.basicDetails.StateName === '' && submeet && 'parsley-error'}`}
                className={`form-control ${validateField(patientFormData.basicDetails.StateName, 50).isInvalid ? 'is-invalid' : ''}`}
                value={patientFormData.basicDetails.StateName}
                name="StateName"
                required=""
                onChange={changeHandler}
              />
              {/* {patientFormData.basicDetails.StateName === '' && submeet && (
                <ul className="parsley-errors-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              )} */}
              {validateField(patientFormData.basicDetails.StateName, 50)
                .errorMessage && (
                <span className="error">
                  {
                    validateField(patientFormData.basicDetails.StateName, 50)
                      .errorMessage
                  }
                </span>
              )}
            </div>

            <div className="form-group col-lg-6 col-md-12">
              <label>
                Country<span className="mandatory_fields">*</span>
              </label>
              <input
                className={`form-control ${validateField(patientFormData.basicDetails.country, 50).isInvalid ? 'is-invalid' : ''}`}
                value={patientFormData.basicDetails.country}
                name="country"
                required=""
                onChange={changeHandler}
              />
              {validateField(patientFormData.basicDetails.country, 50)
                .errorMessage && (
                <span className="error">
                  {
                    validateField(patientFormData.basicDetails.country, 50)
                      .errorMessage
                  }
                </span>
              )}
            </div>

            <div className="form-group col-lg-6 col-md-12">
              <label>
                Pin
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${(patientFormData.basicDetails.zip === '' || !/^\d{1,6}$/.test(patientFormData.basicDetails.zip)) && submeet && 'parsley-error'}`}
                className={`form-control ${touchedFields.zip && !validateIsNumber(patientFormData.basicDetails.zip) ? 'is-invalid' : ''}`}
                value={patientFormData.basicDetails.zip}
                name="zip"
                required=""
                // onChange={(e) => {
                // const value = e.target.value;
                // if (/^\d{0,6}$/.test(value)) {
                //     setFormData((prevData) => ({
                //     ...prevData,
                //     zip: value,
                //     }));
                //     setSubmeet(false);
                // }
                // }}
                onChange={(e) => {
                  changeHandler(e);
                  setTouchedFields({ ...touchedFields, zip: true });
                }}
              />
              {/* {patientFormData.basicDetails.zip === '' && submeet ? (
                <ul className="parsley-errors-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              ) : null} */}
              {touchedFields.zip &&
                !validateIsNumber(patientFormData.basicDetails.zip) && (
                  <span className="error">
                    Please enter a valid number in zip.
                  </span>
                )}
            </div>
          </div>

          {/* Temporary address */}
          <div className="flex col-lg-6 col-md-12 grey-box">
            <div style={{ display: 'flex' }}>
              <h6
                style={{ maxWidth: 'fit-content' }}
                className="col-lg-12 col-md-12"
              >
                Temporary Address
              </h6>
              <div className="col-md-12">
                <input
                  type="checkbox"
                  checked={patientFormData.basicDetails.tempAddrSameAsPermanent}
                  name="tempAddrSameAsPermanent"
                  onChange={(e) => {
                    setPatientFormData({
                      ...patientFormData,
                      basicDetails: {
                        ...patientFormData.basicDetails,
                        tempAddrSameAsPermanent: e.target.checked,
                      },
                    });
                  }}
                  className="mr-1"
                  id="tempAddrSameAsPermanent"
                />
                <label htmlFor="tempAddrSameAsPermanent">
                  Same as permanent
                </label>
              </div>
            </div>

            <div className="form-group col-lg-6 col-md-12">
              <label>Street Address</label>
              <input
                disabled={patientFormData.basicDetails.tempAddrSameAsPermanent}
                className={`form-control`}
                value={
                  patientFormData.basicDetails.tempAddrSameAsPermanent
                    ? patientFormData.basicDetails.address
                    : patientFormData.basicDetails.tempAddress
                }
                name="tempAddress"
                required=""
                onChange={changeHandler}
              />
            </div>

            <div className="form-group col-lg-6 col-md-12">
              <label>City</label>
              <input
                className={`form-control`}
                disabled={patientFormData.basicDetails.tempAddrSameAsPermanent}
                value={
                  patientFormData.basicDetails.tempAddrSameAsPermanent
                    ? patientFormData.basicDetails.CityName
                    : patientFormData.basicDetails.tempCityName
                }
                name="tempCityName"
                required=""
                onChange={changeHandler}
              />
            </div>

            <div className="form-group col-lg-6 col-md-12">
              <label>State</label>
              <input
                className={`form-control`}
                disabled={patientFormData.basicDetails.tempAddrSameAsPermanent}
                value={
                  patientFormData.basicDetails.tempAddrSameAsPermanent
                    ? patientFormData.basicDetails.StateName
                    : patientFormData.basicDetails.tempStateName
                }
                name="tempStateName"
                required=""
                onChange={changeHandler}
              />
            </div>

            <div className="form-group col-lg-6 col-md-12">
              <label>Country</label>
              <input
                className={`form-control`}
                disabled={patientFormData.basicDetails.tempAddrSameAsPermanent}
                value={
                  patientFormData.basicDetails.tempAddrSameAsPermanent
                    ? patientFormData.basicDetails.country
                    : patientFormData.basicDetails.tempCountry
                }
                name="tempCountry"
                required=""
                onChange={changeHandler}
              />
            </div>

            <div className="form-group col-lg-6 col-md-12">
              <label>Pin</label>
              <input
                className={`form-control `}
                disabled={patientFormData.basicDetails.tempAddrSameAsPermanent}
                value={
                  patientFormData.basicDetails.tempAddrSameAsPermanent
                    ? patientFormData.basicDetails.zip
                    : patientFormData.basicDetails.tempzip
                }
                name="tempzip"
                required=""
                onChange={changeHandler}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicDetails;
